import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import VideoLibrary from '@/views/VideoLibrary'
import Video from '@/views/Video'
import Login from '@/views/Login'
import Pricing from '@/views/Pricing'
import WhoWeAre from '@/views/WhoWeAre'
import FAQ from '@/views/FAQ'
import MyChurchProfile from '@/views/MyChurchProfile'
import FindCounselor from '@/views/FindCounselor'
import Checkout from '@/views/Checkout/index.vue'
import SpeakerBios from '@/views/SpeakerBios'
import Speaker from '@/views/Speaker'
import Policy from '@/views/Policy'
import Contact from '@/views/Contact'
import TermsConditions from '@/views/TermsConditions'
import { get } from 'lodash'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: Pricing
  },
  {
    path: '/library',
    name: 'videoLibrary',
    component: VideoLibrary
  },
  {
    path: '/video/:slug',
    name: 'video',
    component: Video
  },
  {
    path: '/who-we-are',
    name: 'whoWeAre',
    component: WhoWeAre
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQ
  },
  {
    path: '/my-church-profile',
    name: 'myChurchProfile',
    component: MyChurchProfile
  },
  {
    path: '/find-a-counselor',
    name: 'findACounselor',
    component: FindCounselor
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: Checkout
  },
  {
    path: '/speaker-bios',
    name: 'speakerBios',
    component: SpeakerBios
  },
  {
    path: '/speaker-bios/:slug',
    name: 'speaker',
    component: Speaker
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: Policy
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    component: Contact
  },
  {
    path: '/terms-conditions',
    name: 'termsConditions',
    component: TermsConditions
  },
  {
    path: '*',
    name: 'notFound',
    component: resolve => import('@/views/NotFound.vue').then(resolve)
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from) {
    return { y: 0 }
  },
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  try {
    if (to.matched.some(record => record.meta.authRequired)) {
      if (!get(store.state.user, 'user.isLoggedIn', false)) {
        next({
          path: '/login'
        })
      } else {
        next()
      }
    } else {
      next()
    }
  } catch (err) {
    console.error(err)
  }
})

export default router
